export enum SherlockDrawerTabKey {
  Details = 'details',
  OrgLinking = 'orgLinking',
  VendorLinking = 'vendorLinking',
  BadAssetsLinking = 'badAssetsLinking',
  Users = 'users',
  LivePayments = 'livePayments',
  Payments = 'payments',
  PaymentsRequests = 'paymentsRequests',
  PayeeOdeHistory = 'payeeOdeHistory',
  PayorOdeHistory = 'payorOdeHistory',
  Transfers = 'transfers',
  Debug = 'debug',
  OrgSanctions = 'orgSanctions',
  VendorSanctions = 'vendorSanctions',
  UserEvents = 'userEvents'
}
